import styles from './AdvtBgVideo.module.css';

import bgVideo from '../../assets/video/bgVideoAdvt.webm';
import bgPoster from '../../assets/images/bgPosterAdvt.webp';

export const AdvtBgVideo = () => {
  return (
    <div className={styles.bgVideoWrapper}>
      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={bgPoster}
      >
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
